import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@components/common'
import './AISummaryModalStyle.css'
import { ICalls } from '@dataTypes/calls.type'
import { getFullName } from '@utils/fullname.util'

type AISummaryModalProps = {
  show: boolean
  onHide: () => void
  callDetails: ICalls
}

const AISummaryModal: React.FC<AISummaryModalProps> = ({
  show,
  onHide,
  callDetails,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="ai-summary-modal">
      <Modal.Header>
        <Modal.Title>
          AI call summary of{' '}
          {callDetails.contact
            ? getFullName(callDetails.contact)
            : callDetails.call_type === 'Incoming'
              ? callDetails.caller_number
              : callDetails.receiver_number}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="asm-summary">
          {callDetails.summary &&
            callDetails.summary.split('\n').map((data, index) => (
              <li key={index} className="asm-summary-item">
                {data}
              </li>
            ))}
        </ul>
        <div className="d-flex justify-content-end">
          <Button className="button-primary" onClick={onHide}>
            Close
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AISummaryModal
